<div class="search-control-group">
  <div #container class="segmented-control">
    <div class="indicator" [ngStyle]="indicatorStyle"></div>
    <div *ngFor="let option of options; let i = index"
         class="segment"
         [class.selected]="selectedOption === option.label"
         (click)="onClickSegment(option.label)">
      <i [class]="option.icon" class="icon"></i>
      <p style="margin-bottom: 0; text-wrap: nowrap">{{ option.label }}</p>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; gap: 10px; flex-grow: 1">
    <input *ngIf="selectedOption === 'Address'" [(ngModel)]="search"
           typeaheadOptionField="SitusStreet"
           [typeahead]="parcels"
           [typeaheadAsync]="true"
           [typeaheadOptionsLimit]="5"
           [optionsListTemplate]="customListTemplate"
           (typeaheadOnSelect)="handleTypeheadOnSelect($event)"
           class="form-control custom-menu"
           placeholder="123 Main Street, Los Angeles CA, 90019">
    <input *ngIf="selectedOption === 'AIN'" class="form-control custom-menu" placeholder="001-002-003" [formControl]="ainFormControl" appNumericSplitter [splitterType]="SplitterType.AIN">

    <button class="btn btn-primary btn-assessor" style="white-space: nowrap" (click)="onClickAdd()" [disabled]="reachedParcelLimit">Add</button>
  </div>
</div>

<ng-template #customListTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
  <ul class="custom-list-group">
    <li
      class="custom-list-group-item"
      *ngFor="let match of matches"
      [class.active]="typeaheadTemplateMethods.isActive(match)"
      (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
      (mouseenter)="typeaheadTemplateMethods.selectActive(match)"
    >
      {{ match.item.SitusStreet + ', ' +  match.item.SitusCity + ', ' +  match.item.SitusZipCode }}
    </li>
  </ul>
</ng-template>
